import { LegalPage, H2, P, UL, useLegalSeo } from "../components/site/Legal";
import { COMPANY } from "../data/site";

export default function Cookies() {
  useLegalSeo("Politique cookies", "Politique d'utilisation des cookies et traceurs du site Habitalys.");
  return (
    <LegalPage title="Politique cookies" updated="octobre 2026" testid="cookies-page">
      <H2>Qu'est-ce qu'un cookie ?</H2>
      <P>Un cookie (ou traceur) est une information déposée sur votre terminal lors de la consultation d'un site. Il permet de mémoriser des données, comme vos choix ou une session de connexion.</P>
      <H2>Traceurs utilisés</H2>
      <UL items={[
        "Strictement nécessaires (exemptés de consentement) : mémorisation de votre choix de cookies (stockage local « habitalys_cookie_consent », 6 mois) ; session sécurisée de l'espace d'administration ; traceurs déposés par Stripe lors d'un paiement, nécessaires à la sécurité et à la prévention de la fraude.",
        "Mesure d'audience (soumise à consentement) : statistiques de fréquentation anonymes destinées à améliorer le site, déposées uniquement si vous cliquez sur « Tout accepter ».",
        "Aucun cookie publicitaire ni de réseau social n'est utilisé.",
      ]} />
      <H2>Votre choix</H2>
      <P>Lors de votre première visite, un bandeau vous permet d'accepter ou de refuser les traceurs non essentiels ; refuser est aussi simple qu'accepter et n'a aucune conséquence sur l'accès au site. Vous pouvez modifier votre choix à tout moment via le lien « Gérer les cookies » en bas de page, ou en supprimant les données du site dans votre navigateur. Votre choix est conservé 6 mois au plus.</P>
      <H2>Contact</H2>
      <P>Pour toute question : {COMPANY.email}. Vous pouvez également consulter les recommandations de la CNIL (www.cnil.fr).</P>
    </LegalPage>
  );
}
